import { TOKEN_NAME, COMPANY_LOCAL_TAG } from '@/constant/config'
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  setUserInfo(state, payload) {
    localStorage.setItem(TOKEN_NAME, JSON.stringify(payload))
    state.userInfo = payload
  },
  setCompanyInfo(state, payload) {
    localStorage.setItem(COMPANY_LOCAL_TAG, JSON.stringify(payload))
    state.companyInfo = payload
  },
  setAMap(state) {
    AMapLoader.load({
      'key': '343301b2c4c56fbf8fad40eca733c8df', // 申请好的Web端开发者Key，首次调用 load 时必填
      'version': '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      'plugins': [
        // 'AMap.Autocomplete',
        // 'AMap.PlaceSearch',
        // 'AMap.Scale',
        // 'AMap.OverView',
        // 'AMap.ToolBar',
        // 'AMap.MapType',
        // 'AMap.PolyEditor',
        // 'AMap.CircleEditor',
        'AMap.Geolocation'
      ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      'AMapUI': { // 是否加载 AMapUI，缺省不加载
        'version': '1.1', // AMapUI 缺省 1.1
        'plugins': [] // 需要加载的 AMapUI ui插件
      },
      'Loca': { // 是否加载 Loca， 缺省不加载
        'version': '1.3.2' // Loca 版本，缺省 1.3.2
      }
    }).then((AMap) => {
      console.log('AMap')
      state.AMap = AMap
    }).catch(e => {
      console.log(e)
    })
  },
  setGeolocation(state, callback = undefined) {
    // console.log('setCurrentLocation')
    if (state.AMap) {
      state.AMap.plugin('AMap.Geolocation', () => {
        // 定位
        state.geolocation = new state.AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, // 显示定位按钮，默认：true
          showMarker: false, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: false, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: false // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
      })
    }
  }
}
